import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
    setApplicationDetails,
    setApplicationRequirementDetails,
    setGeneralDetails,
    setLoginDetails
} from "../../../actions/actions";
import {connect} from "react-redux";

function Sidebar(props) {
     const navigate = useNavigate();
    const location = useLocation();
    const [active, setActive] = useState("");
    const handleLogout = () => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
        props.setOnGeneralDetails("")
        props.setOnApplicationRequirementDetails([])
        navigate("/login");
    };
    const [userData] = useState(props.applicationLogin);
    useEffect(() => {
        if (location.pathname === '/undergraduate/dashboard')
            setActive('dashboard')
        else if (location.pathname === '/undergraduate/personal-information')
            setActive('info')
        else if (location.pathname === '/undergraduate/secondary-school-result')
            setActive('result')
        else if (location.pathname === '/undergraduate/admission-type')
            setActive('admission')
        else if (location.pathname === '/undergraduate/guardian-information')
            setActive('guardian')
        else if (location.pathname === '/undergraduate/document-uploads')
            setActive('document')
        else if (location.pathname === '/undergraduate/application-preview')
            setActive('preview')
        else if (location.pathname === '/undergraduate/jamb-result')
            setActive('jamb')
        else
            setActive('dashboard')
    }, [location])

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li>
                            <h6 className="submenu-hdr"><span>Main</span></h6>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'dashboard' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'dashboard' ? 'text-white' : ''}>Dashboard</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'admission' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'admission' ? 'text-white' : ''}>Admission Type</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'info' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'info' ? 'text-white' : ''}>Personal Information</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'result' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'result' ? 'text-white' : ''}>Olevel Result</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'jamb' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'jamb' ? 'text-white' : ''}>Jamb Result</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'guardian' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'guardian' ? 'text-white' : ''}>Guardian Information</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'document' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'document' ? 'text-white' : ''}>Document Upload</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li style={{ pointerEvents: 'none' }} className={active === 'preview' ? 'btn btn-info btn-sm w-100' : ''}><Link to="/"><span className={active === 'preview' ? 'text-white' : ''}>Preview</span></Link></li>
                            </ul>
                        </li>
                        <li>
                            <ul>
                                <li><div className="widget row pb-4 mb-5 mt-4">
                                    <div className="col-lg-12 col-sm-12">
                                        <button onClick={handleLogout} className="btn btn-sm btn-info w-100 text-white">
                                            Logout
                                        </button>
                                    </div>
                                </div></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationRequirementDetails: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
